import React, { useState } from "react";
import "./Updated.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

function Addfile() {
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const navigtion = useNavigate();
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile && selectedFile.type === "application/pdf") {
      setFile(selectedFile);
    } else {
      toast.error("Please select a PDF file!");
      setFile(null);
    }
  };

  const handleFileNameChange = (e) => {
    setFileName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file || !fileName) {
      toast.error("File and file name are required!");
      return;
    }

    const formData = new FormData();
    formData.append("document_name", fileName);
    formData.append("document", file);

    try {
      const response = await axios.post(
        "https://pricelist.rukmanimfg.com/api/file/uploadfile",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success("File uploaded successfully!");
        setTimeout(() => {
          navigtion("/pricelist");
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.msg || "Something went wrong");
    }
  };

  return (
    <div>
      <ToastContainer />
      <section className="file_upload_section">
        <div className="file_upload_form">
          <h2>Upload File</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="fileName">File Name</label>
              <input
                type="text"
                className="form-control"
                id="fileName"
                placeholder="Enter file name"
                value={fileName}
                onChange={handleFileNameChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="fileInput">Choose File</label>
              <input
                type="file"
                className="form-control"
                id="fileInput"
                onChange={handleFileChange}
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Upload
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}

export default Addfile;
